import React from "react";
import { SealPercent } from "@phosphor-icons/react";

interface OfferBadgeProps {
  text: string;
  backgroundColor: string;
  textColor: string;
}

const OfferBadge: React.FC<OfferBadgeProps> = ({ text, backgroundColor, textColor }) => {
  return (
    <div className="flex items-center gap-1 px-1.5 py-0.5 rounded-md w-fit" style={{ backgroundColor }}>
      <SealPercent size={14} color={textColor} />
      <p className={`text-xxs font-medium`} style={{ color: textColor }}>
        {text}
      </p>
    </div>
  );
};

export default OfferBadge;
